/**
 * ANQ.UserProfile.API 
 * User Profile Service
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface JwtDto { 
    id?: string;
    name?: string;
    tenantId?: string;
    email?: string;
    isEmailVerified?: boolean;
    isRegistered?: boolean;
    roles?: Array<string>;
    validFrom?: Date;
    validTo?: Date;
    token?: string;
    readonly userId?: string;
    readonly username?: string;
}